<template>
    <div class='subscribe-container' :style='styles'>
        <div class='subscribe-content'>
            <div class='subscribe-heading'>Stay informed about our latest offers.</div>
            <div class='subscribe-button-container'>
                <Field id='email_subscribe' label="" :errors='errors' >
                    <input class='subscribe-input-box' type="text" autocomplete="off" v-model='email' placeholder="Enter your email address"/>
                </Field>
                <Button class='subscribe-button' text='subscribe' theme='light'/>
            </div>
        </div>
    </div>
</template>

<script>
import Field from "@/ecom/components/fields/Field.vue";
import Button from "@/ecom/components/buttons/Button.vue";

export default {
    components: {Field, Button},
    props:['element', 'page_builder_mode'],
    data(){
        return{
            errors: {},
            email: '',
            styles:{}
        }
    },
    methods:{
        setStyles(){
            this.styles = this.element.element_config.compiled_styles;
        }
    },
    watch:{
       'element': {
            handler(){
                 this.setStyles();
            },
            deep: true
        }
    },
    mounted(){
        this.setStyles();
    }
}
</script>

<style lang="scss" scoped>
.subscribe-container{
    width: 100%;
    // height: 400px;
    // height: 100%;
    // background-color: #212529;
    display: flex;
    justify-content: center;
    flex-direction: column;
    container-type: inline-size;

    @container(max-width: 768px){
        height: auto !important;
    }
}

.subscribe-content{
    display: flex;
    justify-content: space-between;
    padding: 10%;

    @container(max-width: 768px){
        flex-direction: column;
        gap: 20px;
        // height: auto !important;
    }
}

.subscribe-heading{
    font-size: 2rem;
    color: white;
    font-weight: 300;
}

.subscribe-button-container{
    width: 400px;

    @container(max-width: 768px){
        width: 100%;
    }
}

.subscribe-input-box::placeholder{
    letter-spacing: 0.8px;
    text-transform: uppercase;
    font-size: 0.8rem;
    text-align: center;
}

.subscribe-button{
    margin-top: 10px;
}
</style>